import { render } from "./EnableWhatsAppWidget.vue?vue&type=template&id=b2157074&scoped=true"
import script from "./EnableWhatsAppWidget.vue?vue&type=script&lang=js"
export * from "./EnableWhatsAppWidget.vue?vue&type=script&lang=js"

import "./EnableWhatsAppWidget.vue?vue&type=style&index=0&id=b2157074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2157074"]])

export default __exports__